<template>
  <div class="image-config-container">
    <div class="mb-1 image-config-header">
      <span>
        تصویر
      </span>
      <el-tooltip class="item" effect="dark" :content="toolTipContent"
                  placement="top-start"><i class="el-input__icon el-icon-question sms-tooltip">
      </i></el-tooltip>
      <span v-if="imageUrl" style="color: #381c1c">
        ( JPG PNG JPEG ) حجم تا 2mb
      </span>
    </div>

    <el-upload
        class="upload-demo"
        drag
        :action="`https://magic.payamakapi.ir/api/v1/quickSMSQR/UploadImage`"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        v-loading="loading"
    >
      <div v-if="loading" class="absolute-center">

        <!--        <q-spinner-->
        <!--            color="primary"-->
        <!--            size="3em"-->
        <!--            :thickness="10"-->
        <!--        />-->
      </div>
      <div style="height: 100%" v-else>
        <img v-if="imageUrl" :src="imageUrl" class="upload-img">
        <i v-if="imageUrl" @click.stop="handleRemove" class="el-icon-delete delete-img"></i>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">عکس را رها یا <em>اینجا کلیک کنید</em></div>
        <div class="el-upload__tip" slot="tip">حجم عکس کمتر از 2mb باشد( jpg,png,jpeg )</div>
      </div>

    </el-upload>
  </div>

</template>

<script>


export default {
  name: "UploaderElementUi",
  props: {
    image: {},
    element: {},
    isPattern: {
      default: false
    }
  },
  data() {
    return {
      baseUrl: '',
      imageUrl: '',
      loading: false,
      toolTip: []
    }
  },
  computed: {
    toolTipContent() {
      let width = `طول : ${this.toolTip[0]+'px'}`
      let height = `عرض : ${this.toolTip[1]+'px'}`
      return `${width} ${height}`
    },
  },
  mounted() {
    this.imageUrl = this.image;
    this.toolTip = JSON.parse(localStorage.getItem('CardData')).PaperSize.split(' ');
  },
  methods: {
    handleUploadSuccess(res) {
      this.loading = false
      if (res.Success) {
        this.imageUrl = res.ImageUrl;

        if (this.isPattern) {
          this.$emit('uploadedPattern', this.imageUrl);
        } else {
          this.$emit('changeConfig', {
            props: 'url',
            value: this.imageUrl,
            id: this.element.id
          })
        }
      } else {
        this.$notify.error({
          title: "ناموفق",
          message: res.ErrorMessage,
          offset: 100,
          duration: 3000,
        });
      }
    },
    handleBeforeUpload(image) {
      this.loading = true;

      // image.name.toLowerCase().includes('.jpeg') || !image.name.toLowerCase().includes('.jpg') || !image.name.toLowerCase().includes('.png')

      if ((image.name.includes('jpeg') ||(image.name.includes('JPEG') || image.name.includes('png') || image.name.includes('PNG') ||image.name.includes('JPG'))||image.name.includes('jpg')) && image.size < 2000000) {
        return true;
      } else {
        this.loading = false
        this.$notify.error({
          title: "ناموفق",
          message: 'فرمت عکس باید  PNG,JPEG یا JPG باشد و کمتر از 2 مگابایت',
          offset: 100,
          duration: 3000,
        });
        return false;
      }

    },
    handleRemove() {
      this.imageUrl = ''
    }
  },
  watch: {
    image(val) {
      this.imageUrl = val
    }
  }
}
</script>
<style scoped>
.image-config-container {
  direction: rtl;
}

.upload-img {
  padding: 12px 6px;
  object-fit: contain;
}

.delete-img {
  font-size: 22px;
  position: absolute;
  top: 20px;
  color: #1D1D1D;
  transform: translateX(-150%);
}

.delete-img {
  font-size: 22px;
  position: absolute;
  top: 20px;
  color: #1D1D1D;
  transform: translateX(-150%);
}

.upload-demo {
  direction: rtl;
  display: flex;
  justify-content: center;
}
</style>
